import { NormalizedNumber, promiseAll } from '@sparkdotfi/common-universal'
import { queryOptions } from '@tanstack/react-query'
import { mainnet } from 'viem/chains'
import { Config } from 'wagmi'
import { z } from 'zod'

import { SavingsAccountStats } from '@/config/chain/types'
import { sparkDataApiUrl } from '@/config/consts'
import { stusdsAddress } from '@/config/contracts-generated'
import { normalizedNumberSchema } from '@/domain/common/validation'
import { stusdsWithdrawDataQueryFunction } from '@/features/savings/dialogs/withdraw/logic/stusds/stusdsWithdrawDataQuery'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function stusdsGeneralStatsQueryOptions({ wagmiConfig }: { wagmiConfig: Config }) {
  return queryOptions<SavingsAccountStats>({
    queryKey: ['stusds-general-stats'],
    queryFn: async () => {
      // @todo: replace with stUSDS address from abi cli when available
      const { baData, stusdsWithdrawData } = await promiseAll(
        {
          baData: () => fetch(`${sparkDataApiUrl}/tokens/${stusdsAddress[mainnet.id]}/`),
          stusdsWithdrawData: () => stusdsWithdrawDataQueryFunction({ wagmiConfig, chainId: mainnet.id }),
        },
        { concurrency: 'unbounded' },
      )
      if (!baData.ok) {
        throw new Error('Error fetching savings general stats')
      }
      const result = await baData.json()
      const parsedResult = overallReturnSchema.parse(result)

      const liquidity = NormalizedNumber.max(
        stusdsWithdrawData.totalAssets.minus(stusdsWithdrawData.lockstakeDebt).decimalPlaces(18),
        NormalizedNumber.ZERO,
      )

      return {
        tvl: parsedResult.data.total_supply,
        users: parsedResult.data.number_of_wallets,
        liquidity,
      }
    },
  })
}

const overallReturnSchema = z.object({
  data: z.object({
    total_supply: normalizedNumberSchema,
    number_of_wallets: z.number(),
  }),
  success: z.literal(true),
})
